import * as Types from '../gql/types2';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {"context":{"clientName":"graphql2"}} as const;
export type RequestProjectFolderMoveMutationVariables = Types.Exact<{
  input: Types.RequestProjectFolderMoveCommand;
}>;


export type RequestProjectFolderMoveMutation = { __typename?: 'MutationModel', projectFolders: { __typename?: 'ProjectFoldersMutationModel', requestProjectFolderMove: { __typename?: 'ValidationResponse', errors: Array<{ __typename?: 'ValidationError', argumentName?: string | null, message: string }> } } };

export type CompleteProjectFolderMoveMutationVariables = Types.Exact<{
  input: Types.CompleteProjectFolderMoveCommand;
}>;


export type CompleteProjectFolderMoveMutation = { __typename?: 'MutationModel', projectFolders: { __typename?: 'ProjectFoldersMutationModel', completeProjectFolderMove: { __typename?: 'ValidationResponse', errors: Array<{ __typename?: 'ValidationError', argumentName?: string | null, message: string }> } } };

export type RequestGroupedFolderMoveMutationVariables = Types.Exact<{
  input: Types.RequestGroupedFolderMoveCommand;
}>;


export type RequestGroupedFolderMoveMutation = { __typename?: 'MutationModel', projectFolders: { __typename?: 'ProjectFoldersMutationModel', requestGroupedFolderMove: { __typename?: 'ValidationResponse', errors: Array<{ __typename?: 'ValidationError', argumentName?: string | null, message: string }> } } };

export type CompleteGroupedFolderMoveMutationVariables = Types.Exact<{
  input: Types.CompleteGroupedFolderMoveCommand;
}>;


export type CompleteGroupedFolderMoveMutation = { __typename?: 'MutationModel', projectFolders: { __typename?: 'ProjectFoldersMutationModel', completeGroupedFolderMove: { __typename?: 'ValidationResponse', errors: Array<{ __typename?: 'ValidationError', argumentName?: string | null, message: string }> } } };

export type OverrideGroupedFolderSyncMutationVariables = Types.Exact<{
  input: Types.OverrideGroupedFolderSyncCommand;
}>;


export type OverrideGroupedFolderSyncMutation = { __typename?: 'MutationModel', projectFolders: { __typename?: 'ProjectFoldersMutationModel', overrideGroupedFolderSync: { __typename?: 'ValidationResponse', errors: Array<{ __typename?: 'ValidationError', argumentName?: string | null, message: string }> } } };

export type OverrideProjectFolderSyncMutationVariables = Types.Exact<{
  input: Types.OverrideProjectFolderSyncCommand;
}>;


export type OverrideProjectFolderSyncMutation = { __typename?: 'MutationModel', projectFolders: { __typename?: 'ProjectFoldersMutationModel', overrideProjectFolderSync: { __typename?: 'ValidationResponse', errors: Array<{ __typename?: 'ValidationError', argumentName?: string | null, message: string }> } } };

export type OverrideCustomerFolderSyncMutationVariables = Types.Exact<{
  input: Types.OverrideCustomerFolderSyncCommand;
}>;


export type OverrideCustomerFolderSyncMutation = { __typename?: 'MutationModel', projectFolders: { __typename?: 'ProjectFoldersMutationModel', overrideCustomerFolderSync: { __typename?: 'ValidationResponse', errors: Array<{ __typename?: 'ValidationError', argumentName?: string | null, message: string }> } } };


export const RequestProjectFolderMoveDocument = gql`
    mutation RequestProjectFolderMove($input: RequestProjectFolderMoveCommand!) {
  projectFolders {
    requestProjectFolderMove(input: $input) {
      errors {
        argumentName
        message
      }
    }
  }
}
    `;
export type RequestProjectFolderMoveMutationFn = Apollo.MutationFunction<RequestProjectFolderMoveMutation, RequestProjectFolderMoveMutationVariables>;

/**
 * __useRequestProjectFolderMoveMutation__
 *
 * To run a mutation, you first call `useRequestProjectFolderMoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestProjectFolderMoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestProjectFolderMoveMutation, { data, loading, error }] = useRequestProjectFolderMoveMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestProjectFolderMoveMutation(baseOptions?: Apollo.MutationHookOptions<RequestProjectFolderMoveMutation, RequestProjectFolderMoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestProjectFolderMoveMutation, RequestProjectFolderMoveMutationVariables>(RequestProjectFolderMoveDocument, options);
      }
export type RequestProjectFolderMoveMutationHookResult = ReturnType<typeof useRequestProjectFolderMoveMutation>;
export type RequestProjectFolderMoveMutationResult = Apollo.MutationResult<RequestProjectFolderMoveMutation>;
export type RequestProjectFolderMoveMutationOptions = Apollo.BaseMutationOptions<RequestProjectFolderMoveMutation, RequestProjectFolderMoveMutationVariables>;
export const CompleteProjectFolderMoveDocument = gql`
    mutation CompleteProjectFolderMove($input: CompleteProjectFolderMoveCommand!) {
  projectFolders {
    completeProjectFolderMove(input: $input) {
      errors {
        argumentName
        message
      }
    }
  }
}
    `;
export type CompleteProjectFolderMoveMutationFn = Apollo.MutationFunction<CompleteProjectFolderMoveMutation, CompleteProjectFolderMoveMutationVariables>;

/**
 * __useCompleteProjectFolderMoveMutation__
 *
 * To run a mutation, you first call `useCompleteProjectFolderMoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteProjectFolderMoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeProjectFolderMoveMutation, { data, loading, error }] = useCompleteProjectFolderMoveMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompleteProjectFolderMoveMutation(baseOptions?: Apollo.MutationHookOptions<CompleteProjectFolderMoveMutation, CompleteProjectFolderMoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteProjectFolderMoveMutation, CompleteProjectFolderMoveMutationVariables>(CompleteProjectFolderMoveDocument, options);
      }
export type CompleteProjectFolderMoveMutationHookResult = ReturnType<typeof useCompleteProjectFolderMoveMutation>;
export type CompleteProjectFolderMoveMutationResult = Apollo.MutationResult<CompleteProjectFolderMoveMutation>;
export type CompleteProjectFolderMoveMutationOptions = Apollo.BaseMutationOptions<CompleteProjectFolderMoveMutation, CompleteProjectFolderMoveMutationVariables>;
export const RequestGroupedFolderMoveDocument = gql`
    mutation RequestGroupedFolderMove($input: RequestGroupedFolderMoveCommand!) {
  projectFolders {
    requestGroupedFolderMove(input: $input) {
      errors {
        argumentName
        message
      }
    }
  }
}
    `;
export type RequestGroupedFolderMoveMutationFn = Apollo.MutationFunction<RequestGroupedFolderMoveMutation, RequestGroupedFolderMoveMutationVariables>;

/**
 * __useRequestGroupedFolderMoveMutation__
 *
 * To run a mutation, you first call `useRequestGroupedFolderMoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestGroupedFolderMoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestGroupedFolderMoveMutation, { data, loading, error }] = useRequestGroupedFolderMoveMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestGroupedFolderMoveMutation(baseOptions?: Apollo.MutationHookOptions<RequestGroupedFolderMoveMutation, RequestGroupedFolderMoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestGroupedFolderMoveMutation, RequestGroupedFolderMoveMutationVariables>(RequestGroupedFolderMoveDocument, options);
      }
export type RequestGroupedFolderMoveMutationHookResult = ReturnType<typeof useRequestGroupedFolderMoveMutation>;
export type RequestGroupedFolderMoveMutationResult = Apollo.MutationResult<RequestGroupedFolderMoveMutation>;
export type RequestGroupedFolderMoveMutationOptions = Apollo.BaseMutationOptions<RequestGroupedFolderMoveMutation, RequestGroupedFolderMoveMutationVariables>;
export const CompleteGroupedFolderMoveDocument = gql`
    mutation CompleteGroupedFolderMove($input: CompleteGroupedFolderMoveCommand!) {
  projectFolders {
    completeGroupedFolderMove(input: $input) {
      errors {
        argumentName
        message
      }
    }
  }
}
    `;
export type CompleteGroupedFolderMoveMutationFn = Apollo.MutationFunction<CompleteGroupedFolderMoveMutation, CompleteGroupedFolderMoveMutationVariables>;

/**
 * __useCompleteGroupedFolderMoveMutation__
 *
 * To run a mutation, you first call `useCompleteGroupedFolderMoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteGroupedFolderMoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeGroupedFolderMoveMutation, { data, loading, error }] = useCompleteGroupedFolderMoveMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompleteGroupedFolderMoveMutation(baseOptions?: Apollo.MutationHookOptions<CompleteGroupedFolderMoveMutation, CompleteGroupedFolderMoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteGroupedFolderMoveMutation, CompleteGroupedFolderMoveMutationVariables>(CompleteGroupedFolderMoveDocument, options);
      }
export type CompleteGroupedFolderMoveMutationHookResult = ReturnType<typeof useCompleteGroupedFolderMoveMutation>;
export type CompleteGroupedFolderMoveMutationResult = Apollo.MutationResult<CompleteGroupedFolderMoveMutation>;
export type CompleteGroupedFolderMoveMutationOptions = Apollo.BaseMutationOptions<CompleteGroupedFolderMoveMutation, CompleteGroupedFolderMoveMutationVariables>;
export const OverrideGroupedFolderSyncDocument = gql`
    mutation OverrideGroupedFolderSync($input: OverrideGroupedFolderSyncCommand!) {
  projectFolders {
    overrideGroupedFolderSync(input: $input) {
      errors {
        argumentName
        message
      }
    }
  }
}
    `;
export type OverrideGroupedFolderSyncMutationFn = Apollo.MutationFunction<OverrideGroupedFolderSyncMutation, OverrideGroupedFolderSyncMutationVariables>;

/**
 * __useOverrideGroupedFolderSyncMutation__
 *
 * To run a mutation, you first call `useOverrideGroupedFolderSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOverrideGroupedFolderSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [overrideGroupedFolderSyncMutation, { data, loading, error }] = useOverrideGroupedFolderSyncMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOverrideGroupedFolderSyncMutation(baseOptions?: Apollo.MutationHookOptions<OverrideGroupedFolderSyncMutation, OverrideGroupedFolderSyncMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OverrideGroupedFolderSyncMutation, OverrideGroupedFolderSyncMutationVariables>(OverrideGroupedFolderSyncDocument, options);
      }
export type OverrideGroupedFolderSyncMutationHookResult = ReturnType<typeof useOverrideGroupedFolderSyncMutation>;
export type OverrideGroupedFolderSyncMutationResult = Apollo.MutationResult<OverrideGroupedFolderSyncMutation>;
export type OverrideGroupedFolderSyncMutationOptions = Apollo.BaseMutationOptions<OverrideGroupedFolderSyncMutation, OverrideGroupedFolderSyncMutationVariables>;
export const OverrideProjectFolderSyncDocument = gql`
    mutation OverrideProjectFolderSync($input: OverrideProjectFolderSyncCommand!) {
  projectFolders {
    overrideProjectFolderSync(input: $input) {
      errors {
        argumentName
        message
      }
    }
  }
}
    `;
export type OverrideProjectFolderSyncMutationFn = Apollo.MutationFunction<OverrideProjectFolderSyncMutation, OverrideProjectFolderSyncMutationVariables>;

/**
 * __useOverrideProjectFolderSyncMutation__
 *
 * To run a mutation, you first call `useOverrideProjectFolderSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOverrideProjectFolderSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [overrideProjectFolderSyncMutation, { data, loading, error }] = useOverrideProjectFolderSyncMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOverrideProjectFolderSyncMutation(baseOptions?: Apollo.MutationHookOptions<OverrideProjectFolderSyncMutation, OverrideProjectFolderSyncMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OverrideProjectFolderSyncMutation, OverrideProjectFolderSyncMutationVariables>(OverrideProjectFolderSyncDocument, options);
      }
export type OverrideProjectFolderSyncMutationHookResult = ReturnType<typeof useOverrideProjectFolderSyncMutation>;
export type OverrideProjectFolderSyncMutationResult = Apollo.MutationResult<OverrideProjectFolderSyncMutation>;
export type OverrideProjectFolderSyncMutationOptions = Apollo.BaseMutationOptions<OverrideProjectFolderSyncMutation, OverrideProjectFolderSyncMutationVariables>;
export const OverrideCustomerFolderSyncDocument = gql`
    mutation OverrideCustomerFolderSync($input: OverrideCustomerFolderSyncCommand!) {
  projectFolders {
    overrideCustomerFolderSync(input: $input) {
      errors {
        argumentName
        message
      }
    }
  }
}
    `;
export type OverrideCustomerFolderSyncMutationFn = Apollo.MutationFunction<OverrideCustomerFolderSyncMutation, OverrideCustomerFolderSyncMutationVariables>;

/**
 * __useOverrideCustomerFolderSyncMutation__
 *
 * To run a mutation, you first call `useOverrideCustomerFolderSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOverrideCustomerFolderSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [overrideCustomerFolderSyncMutation, { data, loading, error }] = useOverrideCustomerFolderSyncMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOverrideCustomerFolderSyncMutation(baseOptions?: Apollo.MutationHookOptions<OverrideCustomerFolderSyncMutation, OverrideCustomerFolderSyncMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OverrideCustomerFolderSyncMutation, OverrideCustomerFolderSyncMutationVariables>(OverrideCustomerFolderSyncDocument, options);
      }
export type OverrideCustomerFolderSyncMutationHookResult = ReturnType<typeof useOverrideCustomerFolderSyncMutation>;
export type OverrideCustomerFolderSyncMutationResult = Apollo.MutationResult<OverrideCustomerFolderSyncMutation>;
export type OverrideCustomerFolderSyncMutationOptions = Apollo.BaseMutationOptions<OverrideCustomerFolderSyncMutation, OverrideCustomerFolderSyncMutationVariables>;